/* eslint-disable prettier/prettier */
/* eslint-disable */

/* LearnersAssignedModal.tsx */

import React from 'react';

import styles from './LearnersAssignedModal.module.css';
import Dropdown from '../../../../components/controlVariations/DropdownProgram';
import LearnerTable from '../learner/LearnerTable';

/* DROPDOWN */
// import Dropdown from '../Dropdown/Dropdown';

/* TABLE */
// import LearnerTable from '../LearnerTable/LearnerTable';

export interface LearnersAssignedModalProps<T> {
	isOpen: boolean;
	onClose: () => void;

	/* TITLE */
	title?: string;

	/* DROPDOWN */
	dropdownLabel?: string;

	dropdownPlaceholder?: string;

	dropdownOptions: { label: string; value: string }[];

	selectedDropdown?: string;

	onDropdownSelect: (value: string) => void;

	/* TABLE */
	columns: {
		header: string;
		key: keyof T | 'actions' | 'progress';
		render?: (item: T) => React.ReactNode;
		optional?: boolean;
	}[];

	data: T[];

	itemsPerPage?: number;
}

const LearnersAssignedModal = <T extends { id: string | number }>({
	isOpen,
	onClose,

	title = 'Learners Assigned',

	dropdownLabel = 'Program',

	dropdownPlaceholder = 'Select Program',

	dropdownOptions,
	selectedDropdown,
	onDropdownSelect,

	columns,
	data,

	itemsPerPage = 5,
}: LearnersAssignedModalProps<T>) => {
	if (!isOpen) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{/* HEADER */}
				<div className={styles.header}>
					{/* <h2 className={styles.title}>
                        {title}
                    </h2>

                    <div className={styles.rightSection}>

                        <div className={styles.dropdownSection}>

                            <span className={styles.dropdownLabel}>
                                {dropdownLabel}
                            </span>

                            <Dropdown
                                placeholder={dropdownPlaceholder}
                                options={dropdownOptions}
                                selected={selectedDropdown}
                                onSelect={onDropdownSelect}
                                width="445px"
                                height="48px"
                            />

                        </div>

                        <button
                            className={styles.closeButton}
                            onClick={onClose}
                        >
                            ✕
                        </button>

                    </div> */}
					<div className={styles.headerTop}>
						<h2 className={styles.title}>{title}</h2>

						<button
							className={styles.closeButton}
							onClick={onClose}
						>
							✕
						</button>
					</div>

					<div className={styles.dropdownSection}>
						<span className={styles.dropdownLabel}>
							{dropdownLabel}
						</span>

						<Dropdown
							placeholder={dropdownPlaceholder}
							options={dropdownOptions}
							selected={selectedDropdown}
							onSelect={onDropdownSelect}
							width="100%"
							height="48px"
						/>
					</div>
				</div>

				{/* TABLE */}
				<div className={styles.tableContainer}>
					<LearnerTable
						data={data}
						columns={columns}
						itemsPerPage={itemsPerPage}
						stripedRows={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default LearnersAssignedModal;
